<template>
    <div class="modal-overlay">
      <div class="modal-container modal-full-width">
        <!-- Header -->
        <div class="modal-header">
            <h5 class="modal-title">Realizar Avaliação - {{ prova.dados.avaliacaonome }}</h5>
            <button type="button" class="btn-close" @click="fecharModal"></button>
        </div>

        <div class="modal-content">
          <p></p>
          <!-- Corpo do Modal -->
          <div class="modal-body">
            <!-- Dados da Avaliação -->
            <div class="mb-4">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <h6 style="margin: 0;">Aluno: <span style="color: blue;">{{ prova.dados.aluno }}</span></h6>
              <p style="margin: 0; text-align: right;">Data: {{ prova.dados.data }}</p>
            </div>
            <h6>
                <p></p>
                <p>Instrutor: {{ prova.dados.instrutor }} - Turma: {{ prova.dados.turma }} - {{ prova.dados.nivel }}</p>
            </h6>
            </div>            
            <!-- Questões Agrupadas por Categoria -->
            <div v-for="(grupo, index) in prova.categorias" :key="index" class="mb-3">
              <h6 class="bg-light p-2">{{ grupo.categoria }}</h6>
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 50%;">Requisito</th>
                    <th>Avaliação</th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="q in grupo.questoes" :key="q.id">
                    <td>
                      <div>{{ q.bloco }}</div>
                    </td>
                    <td>
                      <div>
                        <!-- Renderizar input conforme o tipo_dado -->
                        <template v-if="q.tipo_dado === 'Lista'">
                          <select v-model="respostas[q.id]" class="form-select">
                            <option value="">Selecione...</option>
                            <option v-for="op in q.opcoes" :key="op.id" :value="op.opcao">
                              {{ op.opcao }}
                            </option>
                          </select>
                        </template>
                        <template v-else-if="q.tipo_dado === 'Múltipla seleção'">
                          <div v-for="op in q.opcoes" :key="op.id" class="form-check">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              :id="`q_${q.id}_op_${op.id}`"
                              :value="op.opcao"
                              v-model="respostas[q.id]"
                            />
                            <label class="form-check-label" :for="`q_${q.id}_op_${op.id}`">
                              {{ op.opcao }}
                            </label>
                          </div>
                        </template>
                        <template v-else-if="q.tipo_dado === 'Inteiro'">
                          <input type="number" v-model.number="respostas[q.id]" class="form-control" />
                        </template>
                        <template v-else-if="q.tipo_dado === 'Booleano'">
                          <input type="checkbox" v-model="respostas[q.id]" />
                        </template>
                        <template v-else-if="q.tipo_dado === 'Texto'">
                          <input type="text" v-model="respostas[q.id]" class="form-control" />
                        </template>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>


            <div class="mb-3">
              <h6 for="observacoesInstrutor" class="form-label">Observações:</h6>
              <textarea 
                id="observacoesInstrutor" 
                class="form-control textarea-observacao" 
                v-model="observacoesInstrutor" 
                rows="3">
              </textarea>
            </div>

            <!-- logo após o textarea de observacoesInstrutor -->
            <div v-if="observacoesSupervisor" class="mb-3">
              <h6 for="observacoesSupervisor" class="form-label">Observações do Supervisor:</h6>
              <textarea
                id="observacoesSupervisor"
                class="form-control textarea-observacao"
                v-model="observacoesSupervisor"
                rows="3"
                disabled
              ></textarea>
            </div>

          </div>
          
          <!-- Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fecharModal">Cancelar</button>
            <button
              :class="['btn', isSubmitting ? 'btn-success' : 'btn-primary']"
              @click="salvarRespostas"
              :disabled="!formValido || isSubmitting"
            >
              {{ isSubmitting ? 'Salvando…' : 'Salvar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, computed, onMounted } from 'vue';
  import axios from '@/services/axios';
  import { toast } from 'vue3-toastify';

  
  const props = defineProps({
    avaliacaoId: { type: Number, required: true },
    modoEdicao: { type: Boolean, default: false }
  });
  const emit = defineEmits(['close', 'salvou']);
  const isSubmitting = ref(false);

  
  // Estrutura da prova recebida do endpoint
  const prova = reactive({
    dados: {
      avaliacaoNome: '',
      instrutor: '',
      aluno: '',
      turma: '',
      nivel: '',
      data: ''
    },
    categorias: []  // Cada item: { categoria: "Nome Categoria", questoes: [ { id, questao, tipo_dado, bloco, opcoes } ] }
  });
  
  // Objeto para armazenar respostas; chave: id da questão, valor: resposta
  const respostas = reactive({});
  
  const observacoesInstrutor = ref('');
  const observacoesSupervisor = ref('');

  const formValido = computed(() => {
    let valido = true;
    prova.categorias.forEach(grupo => {
      grupo.questoes.forEach(q => {
        if(q.tipo_dado !== 'Booleano') {
          // Para "Múltipla seleção" é esperado um array com pelo menos 1 item
          if(q.tipo_dado === 'Múltipla seleção') {
            if(!Array.isArray(respostas[q.id]) || respostas[q.id].length === 0) {
              valido = false;
            }
          } else {
            if(respostas[q.id] === '' || respostas[q.id] === null || respostas[q.id] === undefined) {
              valido = false;
            }
          }
        }
      });
    });
    return valido;
  });
  
  async function carregarProva() {
    try {
        const response = await axios.get(`/cadastros/avaliacoes-periodos-provas/${props.avaliacaoId}/prova`);
        Object.assign(prova.dados, response.data.dados);
        prova.categorias = response.data.categorias;
        // Se o endpoint já retornar "respostas", usamos:
        if (response.data.respostas) {
        Object.assign(respostas, response.data.respostas.respostas);

        observacoesInstrutor.value = response.data.respostas.observacoes_instrutor || '';
        observacoesSupervisor.value = response.data.respostas.observacoes_supervisor || '';
        } else {
        // Inicializa para cada questão, se não houver respostas salvas
        prova.categorias.forEach(grupo => {
            grupo.questoes.forEach(q => {
            respostas[q.id] = q.tipo_dado === 'Múltipla seleção' ? [] : '';
            });
        });
        }
    } catch (error) {
        console.error("Erro ao carregar dados da prova:", error);
    }
  }
  
  async function salvarRespostas() {
    if (isSubmitting.value) return;
    isSubmitting.value = true;

    const payload = {
      id_avaliacao_periodo_prova: props.avaliacaoId,
      respostas: JSON.parse(JSON.stringify(respostas)),  // Converte o objeto reativo para um objeto simples
      observacoes_instrutor: observacoesInstrutor.value,   // Acessa o valor de ref
      observacoes_supervisor: observacoesSupervisor.value  // Supondo que esta variável também é uma ref
    };

    try {
      await axios.post(`/cadastros/avaliacoes-periodos-provas/respostas`, payload);
      if (props.modoEdicao) {
        toast.success("Respostas atualizadas com sucesso!");
      } else {
        toast.success("Respostas salvas com sucesso!");
      }
      emit('salvou');
      fecharModal();
    } catch (error) {
      console.error("Erro ao salvar respostas:", error);
      toast.error("Erro ao salvar as respostas.");
    } finally {
      isSubmitting.value = false;
    }
  }
  
  function fecharModal() {
    emit('close');
  }
  
  onMounted(() => {
    carregarProva();
  });
  </script>
  
  <style scoped>

  .modal-overlay {
    position: fixed; top:0; left:0; right:0; bottom:0;
    background: rgba(0,0,0,.5);
    display: flex; align-items: center; justify-content: center;
    z-index: 1050;
  }
  .modal-container {
    background: #fff; width: 100%; max-width: 700px;
    border-radius: 0; overflow: hidden;
  }
  .modal-header {
    background: #f5f5f5; padding: .75rem 1rem;
    display: flex; justify-content: space-between; align-items: center;
  }
  .modal-body { padding: 1rem; max-height: 70vh; overflow-y: auto; }
  .modal-footer {
    padding: .75rem 1rem; display: flex; justify-content: flex-end; gap: .5rem;
    background: #f5f5f5;
  }

.modal-body label.form-label,
.modal-body .form-check-label {
  font-size: 0.7rem;
}

/* Reduz tamanho dos checkboxes de múltipla seleção */
.form-check-input {
  width: 10px;
  height: 10px;
}

/* Torna o container flex para alinhar checkbox + texto */
/* Alinha checkbox + texto exatamente no centro */
.modal-body .form-check {
  display: flex !important;
  align-items: center !important;
  margin-bottom: 0.25rem;
}

/* Remove margens/paddings padrões do input */
.modal-body .form-check-input {
  margin: 0 !important;
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
}

/* Garante que o label não tenha margin que atrapalhe */
.modal-body .form-check-label {
  margin: 0 0 0 0.5rem !important; /* 0.5rem de espaço após o checkbox */
  padding: 0;
}

/* Para todas as linhas numéricas e de múltipla seleção */
.modal-body .d-flex.align-items-center.mb-2 {
  align-items: baseline !important;
}

/* Garante um gap razoável entre texto e select */
.modal-body .d-flex.align-items-baseline > .form-select {
  margin-left: 0.5rem;
}

.btn {
  min-width: 70px;
  padding: 6px 15px;
  font-size: 14px;
  cursor: pointer;
  border: none;
}


.required { color: red; }

.textarea-observacao {
  height: auto !important;
  min-height: 100px !important;
  resize: vertical;
}

  </style>
  